/**
 * The Help button is bigger the first time it is seen, and again after each sign-in or new
 * account, then smaller once it has been on screen a few seconds or opened. Whether it has been
 * seen is remembered in the browser. If the browser will not store anything, it stays small
 * rather than shouting on every page.
 */
const SEEN_KEY = "gridaction.help.seen";
const ATTENTION_EVENT = "gridaction:help-attention";

/** How long the big button stays big if nobody opens it. */
export const HELP_SEEN_AFTER_MS = 10_000;

/** True when the button has not been seen yet in this browser, or not since the last sign-in. */
export function helpNeedsAttention(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) !== "1";
  } catch {
    return false;
  }
}

export function markHelpSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, "1");
  } catch {
    // Not remembering is fine.
  }
}

/** Called after a sign-in or sign-up: the button is big again on the next screen. */
export function requestHelpAttention(): void {
  try {
    localStorage.removeItem(SEEN_KEY);
  } catch {
    return;
  }
  window.dispatchEvent(new Event(ATTENTION_EVENT));
}

/** Runs the listener whenever a sign-in asks for the big button. Returns a way to stop listening. */
export function onHelpAttention(listener: () => void): () => void {
  window.addEventListener(ATTENTION_EVENT, listener);
  return () => window.removeEventListener(ATTENTION_EVENT, listener);
}
